import store from '../store'
import * as date from './date'

/**
 * 界面锁定（删除记录时用），使用let lock = this.$base.lock(this), lock.close()
 * @param ctx
 * @returns {ElLoadingComponent | *}
 */
export function lock (ctx) {
  return ctx.$loading({
    lock: false,
    text: '',
    spinner: 'el-icon-loading',
    target: document.querySelector('#work-container') != null ? document.querySelector('#work-container') : document.body
  })
}

/**
 * 成功提示
 * @param ctx
 * @param rr
 * @param callback
 */
export function success (ctx, rr, callback) {
  if (!callback) {
    if (rr.message) {
      ctx.$message({
        message: rr.message, type: 'success', duration: 1000
      })
    } else {
      ctx.$message({
        message: rr, type: 'success', duration: 1000
      })
    }
  } else {
    if (rr.message) {
      ctx.$message({
        message: rr.message, type: 'success', duration: 1000, onClose: callback
      })
    } else {
      ctx.$message({
        message: rr, type: 'success', duration: 1000, onClose: callback
      })
    }
  }
}

/**
 * 错误提示
 * @param ctx
 * @param rr
 * @param callback
 */
export function failure (ctx, rr, callback) {
  if (!callback) {
    if (rr.code) {
      if (rr.code === 901) {
        let field = null
        for (let key in rr.data) {
          field = rr.data[key]
          break
        }
        if (field != null) {
          ctx.$message({
            message: field.tip, type: 'warning', duration: 1500
          })
        }
      } else {
        ctx.$message({
          message: rr.data.detail, type: 'warning', duration: 1500
        })
      }
    } else {
      ctx.$message({
        message: rr, type: 'warning', duration: 1500
      })
    }
  } else {
    if (rr.code) {
      if (rr.code === 901) {
        let field = null
        for (let key in rr.data) {
          field = rr.data[key]
          break
        }
        if (field != null) {
          ctx.$message({
            message: field.tip, type: 'warning', duration: 1500, onClose: callback
          })
        }
      } else {
        ctx.$message({
          message: rr.data.detail, type: 'warning', duration: 1500, onClose: callback
        })
      }
    } else {
      ctx.$message({
        message: rr, type: 'warning', duration: 1500, onClose: callback
      })
    }
  }
}

/**
 * 分页列表:空
 * @type {{recordList: Array, pageCount: string, recordCount: number, pageIndex: number, pageSize: string}}
 */
export const pageList = {
  recordList: [],
  pageCount: 0,
  recordCount: 0,
  pageIndex: 1,
  pageSize: 10,
  form: {}
}

/**
 * 字典代码转文本：this.$base.dictText('BOOL', '0')
 * @param memoni
 * @param code
 * @returns {*}
 */
export function dictText (memoni, code) {
  let text = !code ? '' : '[' + code + ']'
  let items = store.state.session.dictMap[memoni] || []
  for (let i = 0; i < items.length; i++) {
    if (items[i].dict_code === code) {
      return items[i].dict_text
    }
  }
  return text
}

/**
 * 字典代码文本列表：this.$base.dictList('BOOL')
 * @param memoni
 * @returns {*} List<code,text>
 */
export function dictList (memoni) {
  let arr = []
  let items = store.state.session.dictMap[memoni] || []
  for (let i = 0; i < items.length; i++) {
    arr.push({code: items[i].dict_code, text: items[i].dict_text})
  }
  return arr
}

// 缓存tree节点：支持多个字典的树形节点缓存
let dictTreeNodes = {}

/**
 * 获取字典树：用于el-cascader组件填充
 * @param memoni
 * @param digit
 * @returns {*}
 */
export function dictTree(memoni, digit) {
  // 检查当前memoni分组的缓存是否存在且有效
  if (dictTreeNodes[memoni] && dictTreeNodes[memoni].length > 0) {
    return dictTreeNodes[memoni]
  }
  digit = digit ?? 4 // 基础编码长度，默认为4
  const dictList = this.dictList(memoni) // 获取当前memoni对应的字典列表
  const map = {}
  // 初始化当前memoni分组的缓存数组
  dictTreeNodes[memoni] = []
  // 先将每个字典项存储到map中，并初始化children数组
  dictList.forEach(item => {
    map[item.code] = {
      ...item,
      children: []
    }
  })
  // 构建树形结构（支持无限级）
  dictList.forEach(item => {
    const node = map[item.code]
    const codeLength = item.code.length
    const level = codeLength / digit // 动态计算层级
    if (level === 1) {
      // 1级节点作为当前memoni分组的根节点
      dictTreeNodes[memoni].push(node)
    } else {
      // 非1级节点：父节点编码为当前编码截取掉最后digit位
      const parentCode = item.code.slice(0, codeLength - digit)
      const parent = map[parentCode]
      if (parent) {
        parent.children.push(node)
      }
    }
  })
  // 遍历处理：删除没有子节点的children属性
  const traverseAndProcess = (nodes) => {
    nodes.forEach(node => {
      if (node.children && node.children.length === 0) {
        delete node.children
      } else if (node.children) {
        traverseAndProcess(node.children)
      }
    })
  }
  traverseAndProcess(dictTreeNodes[memoni])
  return dictTreeNodes[memoni]
}

/**
 * 根据 code 获取对应的 text，多级代码返回文本组合串
 * @param memoni 助记符
 * @param code 当前代码
 * @param digit 几位一级
 * @returns {*|string}
 */
export const getFullTextByCode = (memoni, code, digit = 4) => {
  const tree = this.dictTree(memoni, digit) // 传入digit确保与树形结构生成逻辑一致
  const map = {}
  // 递归遍历树形结构，生成编码与文本路径的映射
  const traverse = (nodes, parentText = '') => {
    nodes.forEach(node => {
      // 拼接当前节点文本路径（父文本 + 当前文本）
      const currentText = parentText
          ? `${parentText}/${node.text}`  // 可根据需要修改分隔符
          : node.text
      map[node.code] = currentText
      // 递归处理子节点，传递当前文本路径作为父文本
      if (node.children?.length > 0) {
        traverse(node.children, currentText)
      }
    })
  }
  traverse(tree)
  return map[code] || ''
}

/**
 * 根据 dict_code 获取对应的完整编码路径，返回从根到当前节点的编码数组
 * @param memoni 助记符
 * @param code 当前代码
 * @param digit 几位一级
 * @returns {*[]}
 */
export function getFullPathByCode(memoni, code, digit = 4) {
  const tree = this.dictTree(memoni, digit); // 传入digit确保层级计算一致
  const path = [];
  // 递归查找编码路径
  const findPath = (nodes, targetCode) => {
    for (const node of nodes) {
      // 找到目标节点时，先将自身编码加入路径
      if (node.code === targetCode) {
        path.push(node.code);
        return true; // 标记已找到，用于向上递归传递
      }
      // 未找到时，递归查找子节点
      if (node.children?.length > 0) {
        const found = findPath(node.children, targetCode);
        if (found) {
          // 子节点找到后，将当前节点编码加入路径（从下往上收集）
          path.push(node.code);
          return true;
        }
      }
    }
    return false; // 未找到目标节点
  }
  findPath(tree, code);
  return path.reverse(); // 反转后得到从根到当前节点的路径
}

/**
 * 是否显示页面控件：v-if="this.$base.showControl('sys.user.add')"
 * @param memoni
 * @returns {boolean}
 */
export function showControl (memoni) {
  let items = store.state.session.controlList
  for (let i = 0; i < items.length; i++) {
    if (items[i].control_memoni === memoni) {
      return true
    }
  }
  return false
}

/**
 * 格式化日期时间
 * @param str
 * @param pattern
 * @returns {*}
 */
export function formatDateTime (str, pattern) {
  return date.format(str, pattern)
}
